import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { AudioType } from '../model/audio-type';

@Injectable({
  providedIn: 'root'
})
export class AudioService {

  private audioSubscription = new Subject<AudioType>();
  audioPlayer$ = this.audioSubscription.asObservable();

  playAudio(type: AudioType): void {
    this.audioSubscription.next(type);
  }
}
